/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../../app/login/login.component';
const styles_LoginComponent:any[] = ['.gpis-error-panel[_ngcontent-%COMP%] { color: red; padding: 5rem; font-weight: bold; }'];
export const RenderType_LoginComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:0,
    styles:styles_LoginComponent,data:{}});
export function View_LoginComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'h1',[['class',
      'gpis-error-panel']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵted((null as any),['\n    Authorization error. User not allowed in this page.\n']))],
      (null as any),(null as any));
}
export function View_LoginComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'gpis-login',([] as any[]),
      (null as any),(null as any),(null as any),View_LoginComponent_0,RenderType_LoginComponent)),
      i0.ɵdid(49152,(null as any),0,i1.LoginComponent,([] as any[]),(null as any),
          (null as any))],(null as any),(null as any));
}
export const LoginComponentNgFactory:i0.ComponentFactory<i1.LoginComponent> = i0.ɵccf('gpis-login',
    i1.LoginComponent,View_LoginComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiQzovVXNlcnMvU0hSNk0zL0RldmVsb3BtZW50L1BhY2tJVFdlYkd1aS9zcmMvYXBwL2xvZ2luL2xvZ2luLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9DOi9Vc2Vycy9TSFI2TTMvRGV2ZWxvcG1lbnQvUGFja0lUV2ViR3VpL3NyYy9hcHAvbG9naW4vbG9naW4uY29tcG9uZW50LnRzIiwibmc6Ly8vQzovVXNlcnMvU0hSNk0zL0RldmVsb3BtZW50L1BhY2tJVFdlYkd1aS9zcmMvYXBwL2xvZ2luL2xvZ2luLmh0bWwiLCJuZzovLy9DOi9Vc2Vycy9TSFI2TTMvRGV2ZWxvcG1lbnQvUGFja0lUV2ViR3VpL3NyYy9hcHAvbG9naW4vbG9naW4uY29tcG9uZW50LnRzLkxvZ2luQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGgxIGNsYXNzPVwiZ3Bpcy1lcnJvci1wYW5lbFwiPlxyXG4gICAgQXV0aG9yaXphdGlvbiBlcnJvci4gVXNlciBub3QgYWxsb3dlZCBpbiB0aGlzIHBhZ2UuXHJcbjwvaDE+IiwiPGdwaXMtbG9naW4+PC9ncGlzLWxvZ2luPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUE7TUFBQSxnQkFBNkI7Ozs7b0JDQTdCO01BQUE7YUFBQTtVQUFBOzs7In0=



// WEBPACK FOOTER //
// C:/Users/SHR6M3/Development/PackITWebGui/src/$$_gendir/app/login/login.component.ngfactory.ts